export function formatCents(value: string | number): number {
  value = String(value).replace(/\D/g, '') || '0';
  return parseInt(value);
}

export function formatCentsForList(v: string | number): string {
  const value = String(v).replace(/\D/g, '');
  return value.replace(/^0+/, '');
}

export function formatBRLForList(v: string | number): string {
  if (v === 'R$ 0,0' || v === '') return '';
  const value = String(v).replace(/\D/g, '');
  const numericValue = parseInt(value);
  if (isNaN(numericValue) || numericValue === 0) {
    return 'R$ 0,00';
  }
  const formattedValue = (numericValue / 100).toFixed(2);
  let [reais, centavos] = formattedValue.split('.');
  reais = parseInt(reais).toLocaleString('pt-BR');
  return 'R$ ' + reais + ',' + centavos;
}

export function formatPercent(value: string | number): string {
  const numericValue = parseInt(String(value).replace(/\D/g, '').slice(-5));

  if (isNaN(numericValue) || numericValue === 0) {
    return '0,00';
  }
  if (parseInt(String(value).replace(/\D/g, '')) > 10000) {
    return '100,00';
  }
  const formattedValue = (numericValue / 100).toFixed(2);
  let [intPart, fracPart] = formattedValue.split('.');
  return `${intPart},${fracPart}`;
}

export function unformatPercent(value: string | number): string {
  return String(value).replace(',', '.');
}

export function formatNumber(value: string | number): number {
  const numericValue = parseInt(String(value).replace(/\D/g, ''));

  if (isNaN(numericValue)) {
    return 0;
  }
  return numericValue;
}

export function formatFloat(value: number): string {
  let fValue = String(value).replace(/[^0-9]/g, '');
  const integerPart = parseInt(
    fValue.slice(0, fValue.length - 3) || '0',
  ).toLocaleString('pt-BR');
  const fractionPart = fValue.slice(fValue.length - 3);
  return `${integerPart},${fractionPart}`;
}

export function unformatFloat(value: string) {
  let fValue: any = String(value).replace(/[^0-9]/g, '');
  fValue = (parseInt(fValue) / 1000).toFixed(3);
  return parseFloat(fValue);
}

export function formatInteger(value: string | number): string {
  value = String(value).replace(/\D/g, '') || '0';
  const numericValue = parseInt(value);
  return numericValue.toLocaleString('pt-BR');
}

export function unformatInteger(value: string | number): number {
  value = String(value).replace(/\D/g, '') || '0';
  return parseInt(value);
}

export function formatBRL(value: string | number): string {
  value = String(value).replace(/\D/g, '');
  const numericValue = parseInt(value);
  if (isNaN(numericValue) || numericValue === 0) {
    return 'R$ 0,00';
  }

  const formattedValue = (numericValue / 100).toFixed(2);
  let [reais, centavos] = formattedValue.split('.');
  reais = parseInt(reais).toLocaleString('pt-BR');

  return 'R$ ' + reais + ',' + centavos;
}

export const formatDate = (value) => {
  let v = value.replace(/\D/g, '').slice(0, 8);
  if (v.length >= 5) {
    return `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
  } else if (v.length >= 3) {
    return `${v.slice(0, 2)}/${v.slice(2)}`;
  }
  return v;
};

export function formatCompleteBRL(value: string | number): string {
  const isNegative = String(value).includes('-');
  value = String(value).replace(/\D/g, '');
  const numericValue = parseInt(value);
  if (isNaN(numericValue) || numericValue === 0) {
    return 'R$ 0,00';
  }
  const formattedValue = (numericValue / 100).toFixed(2);
  let [reais, centavos] = formattedValue.split('.');
  reais = parseInt(reais).toLocaleString('pt-BR');
  return (isNegative ? '- R$ ' : 'R$ ') + reais + ',' + centavos;
}

export function formatCompleteCents(value: string | number): number {
  const isNegative = String(value).includes('-');
  value = String(value).replace(/\D/g, '') || '0';
  const numericValue = parseInt(value);
  return isNegative ? -numericValue : numericValue;
}
